import { BustedPlayCSS } from './BustedPlayCSS.styled'
import { Header } from './Header'
import { Graph } from './Graph'
import { BustedUsers } from './BustedUsers'
import { useBustGameLogic } from '../useBustGameData'
import { config } from 'config'
import { useSocket } from 'hooks/sockets/useSocket'

const { BUSTED_SOCKET_URL } = config

export const BustedPlay = () => {
  useSocket('bustabit', BUSTED_SOCKET_URL)
  useBustGameLogic()

  return (
    <BustedPlayCSS>
      <div id='gameplay'>
        {/* <Animation /> */}
        <Header />
        <Graph />
      </div>
      <div id='gameplay_stats'>
        <BustedUsers />
      </div>
    </BustedPlayCSS>
  )
}
